import styled from 'styled-components';
import ScreenUtils from '@screen';
import React from 'react';

const GuideRailLogoImageContainer = styled.div<React.CSSProperties>`
  width: ${131 * ScreenUtils.widthRatio}px;
  height: ${197 * ScreenUtils.widthRatio}px;
  position: relative;
`;

export default GuideRailLogoImageContainer;
